// TODO: need to rename as FormAction
export const FORM_ACTION = {
    create: 'CREATE',
    edit: 'EDIT',
    copy: 'COPY',
    delete: 'DELETE',
    cancel: 'CANCEL'
}

// TODO: need to rename as SurveyType
export const SURVEY_TYPE = {
    onetime: 'ONETIME',
    daily: 'DAILY',
    onetimeTitle: 'One Time',
    dailyTItle: 'Daily',
}

// TODO: need to rename as SurveyHelpText
export const SURVEY_HELP_TEXT = {
    beginTime: 'If blank, the begin time is 12:00 AM',
    endTime: 'If blank, the end time is 11:59 PM',
    weekendPickerTitle: 'Days of week',
    weekendPickerError: 'At least one day must be selected',
    invalidDate: 'Start Date must be before End Date',
    invalidTime: 'Start Time must be before End Time'
}

// TODO: need to rename as SubmissionHelpText
export const SUBMISSION_HELPER_TEXT = {
    onetime: 'Only allow one submission per user',
    daily: 'Only allow one submission per user per day',
}

export const HIDE_CONTROLS = 'none';

export const SHOW_CONTROLS = 'inline';

export const DAYOFWEEK_LABEL = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const DAYOFWEEK_DEFAULT = [1,2,3,4,5,6,7];

export const BEGIN_TIME_DEFAULT = '00:00';

export const END_TIME_DEFAULT = '11:59';

export const UNSELECTED_TIME = null;

export const SharingOption = {
    NO_SHARE: 'NO',
    ANYONE: 'ANYONE',
    SPECIFIC_ORGANIZATIONS: 'SPECIFIC-ORGANIZATIONS',
    TOP_LEVEL_USERS: 'TOP-LEVEL-USERS'
}
